// @flow

import React, { useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import range from 'lodash/range';

import usePath from '../usePath';
import useContactNumber from '../useContactNumber';
import useSelfEnrollment from '../../../hooks/useSelfEnrollment';
import PageHeader from '../PageHeader';
import PageButtons from '../PageButtons';
import Download from './Download';
import { MESSAGES, PATHS, SCENARIOS } from '../constants';

import styles from './styles.module.scss';

const PatientEnrolled = () => {
  const getPath = usePath();
  const contactNumber = useContactNumber();
  const history = useHistory();
  const { selfEnrollmentResponse, setMessage, entityData } = useSelfEnrollment();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    return () => {
      setMessage(MESSAGES.ACCOUNT_PENDING_TO_BE_COMPLETED);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!selfEnrollmentResponse || !selfEnrollmentResponse.success) {
    return <Redirect to={getPath(PATHS.IDENTIFY)} />;
  }

  const onResetPassword = async () => {
    setMessage(MESSAGES.ACCOUNT_PENDING_TO_BE_COMPLETED);
    history.push(getPath(PATHS.FOUND));
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <Download />
      </div>
      <PageHeader
        headerId="app.self-enroll.thank-you.header.sms"
        subHeaderId="app.self-enroll.thank-you.sub-header"
        headerVariant="d2"
      />
      <div className={styles.didntReceiveMessage}>
        <FormattedMessage
          id="app.self-enroll.thank-you.didnt-receive"
          values={{
            button: (content) => (
              <button type="button" className={styles.buttonMessage} onClick={onResetPassword}>
                {content}
              </button>
            ),
          }}
        />
      </div>
      <div className={styles.downloadMessages}>
        <p className={styles.bold}>
          <FormattedMessage id="app.self-enroll.thank-you.why-download" />
        </p>
        <ul>
          {range(1, 4).map((item) => (
            <li key={`download-app-reason-${item}`}>
              <FormattedMessage id={`app.self-enroll.thank-you.why-download.item${item}`} />
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.pageButtonsWrapper}>
        <PageButtons
          scenario={SCENARIOS.IDENTIFY}
          cobrandedLink={entityData?.selfEnrollment?.selfEnrollmentCobrandedLink}
          phoneNumber={contactNumber}
        />
      </div>
    </div>
  );
};

export default PatientEnrolled;
